<ng-container *ngIf="organization.isExistingOrganization">
  <h2>Lizenzverlängerung für {{organization.organizationName}}</h2>

  <table id="companyData" border="0" cellspacing="0" cellpadding="0">

    <tr>
      <td>Derzeitige Lizenz:</td>
      <td style="padding-left: 1em">{{organization.currentLicenseTypeName || "Keine"}}</td>
    </tr>

    <tr>
      <td>Lizenzende:</td>
      <td style="padding-left: 1em">{{organization.currentLicenseEndDate | date: "dd.MM.yyyy"}}</td>
    </tr>

    <tr>
      <td>Verbleibende Zugriffe:</td>
      <td style="padding-left: 1em">{{organization.currentLicenseRemainingLogins}}</td>
    </tr>

  </table>
</ng-container>

<h2>Wählen Sie Ihre Lizenz</h2>

<p>
  Ein Zugriff definiert sich über die ein- oder mehrmalige
  Anmeldung eines Benutzers pro Organisation während eines
  Tages (05:00 bis 03:00 Uhr). Wobei ein Benutzer gleichzeitig
  nur einmal angemeldet sein darf.
</p>

<form id="licenseForm" #f="ngForm">

  <table id="licenseSelectionTable" border="0" cellspacing="0" cellpadding="5">

    <tr style="background: lightgrey">
      <th colspan="2" align="left">Lizenz</th>
      <th align="right">CHF</th>
    </tr>

    <tr *ngFor="let licenseType of availableLicenseTypes">
      <td style="width: 5em; vertical-align: top"><input name="newLicenseTypeName" type="radio" required [value]="licenseType.name" [(ngModel)]="newLicenseTypeName"></td>
      <td style="vertical-align: text-top"><b>{{licenseType.name}}</b><br>{{licenseType.description}}</td>
      <td style="width: 5em; vertical-align: text-top; text-align: right"><b>{{formatPrice(licenseType.priceNet)}}</b></td>
    </tr>

  </table>

  <p>
    Falls die Lizenz nicht {{organization.isCurrentLicenseActive ? "direkt nach Ablauf der bisherigen Lizenz" : "sofort"}}
    aktiviert werden soll, geben Sie bitte das gewünschte Startdatum an:
    <input id="newLicenseBeginDate" name="newLicenseBeginDate" type="date" placeholder="JJJJ-MM-TT" [min]="organization.earliestNewLicenseBeginDate" [(ngModel)]="organization.newLicenseBeginDate">
  </p>

  <p>
    Falls das von Ihnen gewählte Startdatum vor dem Verarbeitungsdatum
    Ihrer Bestellung liegt, ist der Lizenzbeginn das Verarbeitungsdatum.
  </p>

</form>

<div class="buttonRow">
  <button *ngIf="!organization.isExistingOrganization" (click)="appController.previous()">Zurück</button>
  <button (click)="appController.next(f)">Weiter</button>
</div>
